import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { FormGroup, Input } from 'reactstrap'
import { setLatestToolbox } from 'store/AddWidget/actions'
import { setManagerToolbox } from 'store/AddWidget/actions'
import { setEmployeeToolbox } from 'store/AddWidget/actions'
import { setAdminToolbox } from 'store/AddWidget/actions'
import AxiosInstance from 'utils/AxiosInstance'
import SyncChangesForm from './SyncChangesForm'
import { setRefetchToolboxes } from 'store/AddWidget/actions'
import NewWidgetForm from './NewWidgetForm'
import RemoveWidgets from './RemoveWidgets'
import { setAdminLayouts } from 'store/AddWidget/actions'
import { setManagerLayouts } from 'store/AddWidget/actions'
import { setEmployeeLayouts } from 'store/AddWidget/actions'

function AddDashboardWidget() {
  const dispatch = useDispatch()
  const [mode, setMode] = useState('sync')
  const [latestToolboxText, setLatestToolboxText] = useState('')

  const {
    adminToolbox,
    managerToolbox,
    employeeToolbox,
    latestToolbox,
    refetchToolboxes,
  } = useSelector((state) => state.addWidget)

  const latestToolboxIds =
    latestToolbox && latestToolbox.map((toolbox) => toolbox.id)

  const adminToolboxIds =
    adminToolbox && adminToolbox.map((toolbox) => toolbox.id)

  const managerToolboxIds =
    managerToolbox && managerToolbox.map((toolbox) => toolbox.id)

  const employeeToolboxIds =
    employeeToolbox && employeeToolbox.map((toolbox) => toolbox.id)

  const missingAdminToolboxIds =
    latestToolboxIds &&
    adminToolboxIds &&
    latestToolboxIds.filter((id) => !adminToolboxIds.includes(id))

  const missingManagerToolboxIds =
    latestToolboxIds &&
    managerToolboxIds &&
    latestToolboxIds.filter((id) => !managerToolboxIds.includes(id))

  const missingEmployeeToolboxIds =
    latestToolboxIds &&
    employeeToolboxIds &&
    latestToolboxIds.filter((id) => !employeeToolboxIds.includes(id))

  const missingAdminToolboxes =
    latestToolbox &&
    adminToolboxIds &&
    latestToolbox.filter((toolbox) =>
      missingAdminToolboxIds.includes(toolbox.id)
    )

  const missingManagerToolboxes =
    latestToolbox &&
    managerToolboxIds &&
    latestToolbox.filter((toolbox) =>
      missingManagerToolboxIds.includes(toolbox.id)
    )

  const missingEmployeeToolboxes =
    latestToolbox &&
    missingEmployeeToolboxIds &&
    latestToolbox.filter((toolbox) =>
      missingEmployeeToolboxIds.includes(toolbox.id)
    )

  useEffect(() => {
    if (refetchToolboxes) {
      AxiosInstance.get('/users/latest/layout').then((data) => {
        dispatch(setAdminToolbox(JSON.parse(data.layouts[0].toolbox)))
        dispatch(setManagerToolbox(JSON.parse(data.layouts[1].toolbox)))
        dispatch(setEmployeeToolbox(JSON.parse(data.layouts[2].toolbox)))

        dispatch(setAdminLayouts(JSON.parse(data.layouts[0].data)))
        dispatch(setManagerLayouts(JSON.parse(data.layouts[1].data)))
        dispatch(setEmployeeLayouts(JSON.parse(data.layouts[2].data)))

        dispatch(setRefetchToolboxes(false))
      })
    }
  }, [dispatch, refetchToolboxes])

  return (
    <div>
      <div className='flex items-center mx-auto text-center mt-2 mb-4'>
        <button
          onClick={() => setMode('sync')}
          className={`btn ${mode === 'sync' && 'btn-info'}`}
        >
          Sync Changes
        </button>
        <button
          onClick={() => setMode('new')}
          className={`btn ${mode === 'new' && 'btn-info'}`}
        >
          New Widget
        </button>
        <button
          onClick={() => setMode('remove')}
          className={`btn ${mode === 'remove' && 'btn-info'}`}
        >
          Remove Widgets
        </button>
      </div>
      {mode === 'sync' && (
        <FormGroup className='ml-5 w-50'>
          <label className='form-control-label' htmlFor='latestToolbox'>
            Latest Toolbox (copy stringified JSON from database)
          </label>
          <Input
            id='latestToolbox'
            name='id'
            type='text'
            style={{ height: '37px' }}
            onChange={(e) => setLatestToolboxText(e.target.value)}
            defaultValue={latestToolboxText}
          />
          <button
            onClick={() => {
              try {
                const parsedData = JSON.parse(latestToolboxText)
                dispatch(setLatestToolbox(parsedData))
              } catch (error) {
                alert('Invalid JSON format.')
                return
              }
            }}
            className='btn btn-info mt-2'
          >
            Save
          </button>
        </FormGroup>
      )}
      {mode === 'sync' && (
        <div className='d-flex align-items-baseline justify-content-between'>
          <div className='mx-5'>
            <h1 className='mb-2'>Admin</h1>
            {missingAdminToolboxes && missingAdminToolboxes.length ? (
              missingAdminToolboxes.map((toolbox) => (
                <SyncChangesForm
                  key={toolbox.id}
                  toolbox={toolbox}
                  dashboardId={1}
                />
              ))
            ) : !latestToolbox ? (
              <p>No data yet!</p>
            ) : (
              <p>Up to date</p>
            )}
          </div>
          <div className='mx-5'>
            <h1 className='mb-2'>Manager</h1>
            {missingManagerToolboxes && missingManagerToolboxes.length ? (
              missingManagerToolboxes.map((toolbox) => (
                <SyncChangesForm
                  key={toolbox.id}
                  toolbox={toolbox}
                  dashboardId={2}
                />
              ))
            ) : !latestToolbox ? (
              <p>No data yet!</p>
            ) : (
              <p>Up to date</p>
            )}
          </div>
          <div className='mx-5'>
            <h1 className='mb-2'>Employee</h1>
            {missingEmployeeToolboxes && missingEmployeeToolboxes.length ? (
              missingEmployeeToolboxes.map((toolbox) => (
                <SyncChangesForm
                  key={toolbox.id}
                  toolbox={toolbox}
                  dashboardId={3}
                />
              ))
            ) : !latestToolbox ? (
              <p>No data yet!</p>
            ) : (
              <p>Up to date</p>
            )}
          </div>
        </div>
      )}
      {mode === 'new' && <NewWidgetForm setMode={setMode} />}
      {mode === 'remove' && <RemoveWidgets />}
    </div>
  )
}

export default AddDashboardWidget
